/* =========================================================
   CUSTOM — PDP Drawers
   Progressive enhancement for Dawn collapsible_tab blocks.
   Native accordion markup is preserved as no-JS fallback.
   ========================================================= */
(function () {
  if (window.__CUSTOM_PDP_DRAWERS__) return;
  window.__CUSTOM_PDP_DRAWERS__ = true;

  var ROOT_ID = 'CustomPdpDrawer';
  var root = null;
  var panel = null;
  var overlay = null;
  var drawerTitle = null;
  var drawerBody = null;
  var closeButton = null;
  var activeTrigger = null;
  var scrollState = null;
  var cleanupTimer = null;

  function closeLabel() {
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    if (lang.indexOf('it') === 0) return 'Chiudi';
    if (lang.indexOf('fr') === 0) return 'Fermer';
    if (lang.indexOf('es') === 0) return 'Cerrar';
    if (lang.indexOf('de') === 0) return 'Schließen';
    return 'Close';
  }

  function isTransparent(color) {
    if (!color) return true;
    return color === 'transparent' || color === 'rgba(0, 0, 0, 0)' || /rgba\([^\)]*,\s*0\s*\)$/.test(color);
  }

  function resolveBackground(start) {
    var node = start;
    while (node && node !== document.documentElement) {
      var bg = window.getComputedStyle(node).backgroundColor;
      if (!isTransparent(bg)) return bg;
      node = node.parentElement;
    }
    var bodyBg = window.getComputedStyle(document.body).backgroundColor;
    return isTransparent(bodyBg) ? '#ffffff' : bodyBg;
  }

  function lockScroll() {
    if (scrollState) return;

    var body = document.body;
    var y = window.scrollY || window.pageYOffset || 0;
    var scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

    scrollState = {
      y: y,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight
    };

    body.style.position = 'fixed';
    body.style.top = '-' + y + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    if (scrollbar > 0) {
      body.style.paddingRight = scrollbar + 'px';
    }

    document.documentElement.classList.add('custom-pdp-drawer-open');
  }

  function unlockScroll() {
    if (!scrollState) return;

    var body = document.body;
    var y = scrollState.y;

    body.style.position = scrollState.position;
    body.style.top = scrollState.top;
    body.style.left = scrollState.left;
    body.style.right = scrollState.right;
    body.style.width = scrollState.width;
    body.style.overflow = scrollState.overflow;
    body.style.paddingRight = scrollState.paddingRight;

    document.documentElement.classList.remove('custom-pdp-drawer-open');
    scrollState = null;

    window.scrollTo(0, y);
  }

  function focusableElements() {
    if (!panel) return [];
    return Array.prototype.slice.call(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.hasAttribute('hidden') && el.getAttribute('aria-hidden') !== 'true';
    });
  }

  function onKeydown(event) {
    if (!root || !root.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusables = focusableElements();
    if (!focusables.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function ensureDrawer() {
    if (root && document.body.contains(root)) return root;

    root = document.getElementById(ROOT_ID);

    if (!root) {
      root = document.createElement('div');
      root.id = ROOT_ID;
      root.className = 'custom-pdp-drawer';
      root.setAttribute('aria-hidden', 'true');

      root.innerHTML =
        '<div class="custom-pdp-drawer__overlay" data-custom-pdp-drawer-close></div>' +
        '<section class="custom-pdp-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="CustomPdpDrawerTitle" tabindex="-1">' +
          '<header class="custom-pdp-drawer__header">' +
            '<h2 class="custom-pdp-drawer__title" id="CustomPdpDrawerTitle"></h2>' +
            '<button class="custom-pdp-drawer__close" type="button" data-custom-pdp-drawer-close></button>' +
          '</header>' +
          '<div class="custom-pdp-drawer__body rte" id="CustomPdpDrawerBody"></div>' +
        '</section>';

      document.body.appendChild(root);
    }

    panel = root.querySelector('.custom-pdp-drawer__panel');
    overlay = root.querySelector('.custom-pdp-drawer__overlay');
    if (overlay) {
      overlay.setAttribute('aria-hidden', 'true');
    }
    drawerTitle = root.querySelector('.custom-pdp-drawer__title');
    drawerBody = root.querySelector('.custom-pdp-drawer__body');
    closeButton = root.querySelector('.custom-pdp-drawer__close');

    if (closeButton) {
      closeButton.setAttribute('aria-label', closeLabel());
    }

    if (root.dataset.customPdpDrawerBound !== 'true') {
      root.dataset.customPdpDrawerBound = 'true';

      if (overlay) {
        overlay.addEventListener('click', closeDrawer);
      }

      root.addEventListener('click', function (event) {
        if (event.target === overlay) {
          closeDrawer();
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeDrawer);
      }

      document.addEventListener('keydown', onKeydown);
    }

    return root;
  }

  function clonePaymentContent(source) {
    if (!source || !source.querySelector('.payment-methods-section')) return null;

    var template = document.getElementById('CustomPdpPaymentMethodsTemplate');
    if (!template || !template.content) return null;

    return template.content.cloneNode(true);
  }

  function cloneContent(source) {
    var clone = source.cloneNode(true);
    clone.removeAttribute('id');

    clone.querySelectorAll('[id]').forEach(function (el) {
      el.removeAttribute('id');
    });

    var fragment = document.createDocumentFragment();
    while (clone.firstChild) {
      fragment.appendChild(clone.firstChild);
    }
    return fragment;
  }

  function openDrawer(trigger, title, source, block, primaryColor) {
    ensureDrawer();

    if (cleanupTimer) {
      window.clearTimeout(cleanupTimer);
      cleanupTimer = null;
    }

    activeTrigger = trigger;

    drawerTitle.textContent = title;

    var paymentContent = clonePaymentContent(source);
    root.classList.toggle('custom-pdp-drawer--payments', Boolean(paymentContent));
    drawerBody.replaceChildren(paymentContent || cloneContent(source));

    root.style.setProperty('--custom-pdp-drawer-background', resolveBackground(block));
    root.style.setProperty(
      '--custom-pdp-drawer-color',
      primaryColor || 'var(--custom-color-text-primary, #16332e)'
    );

    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');

    lockScroll();

    window.requestAnimationFrame(function () {
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      } else if (panel) {
        panel.focus({ preventScroll: true });
      }
    });
  }

  function closeDrawer() {
    if (!root || !root.classList.contains('is-open')) return;

    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
    }

    unlockScroll();

    var triggerToFocus = activeTrigger;
    activeTrigger = null;

    if (triggerToFocus && document.body.contains(triggerToFocus)) {
      triggerToFocus.focus({ preventScroll: true });
    }

    cleanupTimer = window.setTimeout(function () {
      if (drawerBody && !root.classList.contains('is-open')) {
        drawerBody.replaceChildren();
      }
      cleanupTimer = null;
    }, 380);
  }

  function makeArrow() {
    var span = document.createElement('span');
    span.className = 'custom-pdp-drawer-trigger__arrow';
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML =
      '<svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/>' +
      '</svg>';
    return span;
  }

  function enhanceBlock(block) {
    if (!block || block.dataset.customPdpDrawerEnhanced === 'true') return;

    var details = block.querySelector(':scope > details');
    if (!details) return;

    var summary = details.querySelector(':scope > summary');
    var titleEl = summary ? summary.querySelector('.accordion__title') : null;
    var source = details.querySelector('.accordion__content');

    if (!summary || !titleEl || !source) return;

    var title = (titleEl.textContent || '').trim();
    if (!title) return;

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-pdp-drawer-trigger';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', ROOT_ID);
    trigger.setAttribute('aria-expanded', 'false');

    var main = document.createElement('span');
    main.className = 'custom-pdp-drawer-trigger__main';

    var originalIcon = summary.querySelector('.summary__title .svg-wrapper');
    if (originalIcon) {
      var iconWrap = document.createElement('span');
      iconWrap.className = 'custom-pdp-drawer-trigger__icon';
      iconWrap.appendChild(originalIcon.cloneNode(true));
      main.appendChild(iconWrap);
    }

    var label = document.createElement('span');
    label.className = 'custom-pdp-drawer-trigger__label';
    label.textContent = title;

    var primaryColor = window.getComputedStyle(titleEl).color;

    main.appendChild(label);
    trigger.appendChild(main);
    trigger.appendChild(makeArrow());

    trigger.addEventListener('click', function () {
      openDrawer(trigger, title, source, block, primaryColor);
    });

    block.classList.add('custom-pdp-drawer-block');
    block.dataset.customPdpDrawerEnhanced = 'true';

    details.hidden = true;
    details.setAttribute('aria-hidden', 'true');

    block.insertBefore(trigger, details);
  }

  function refreshEdgeClasses(container) {
    var blocks = Array.prototype.slice.call(
      container.querySelectorAll('.product__accordion.custom-pdp-drawer-block')
    );

    blocks.forEach(function (block) {
      block.classList.remove('custom-pdp-drawer-block--first', 'custom-pdp-drawer-block--last');
    });

    if (blocks.length) {
      blocks[0].classList.add('custom-pdp-drawer-block--first');
      blocks[blocks.length - 1].classList.add('custom-pdp-drawer-block--last');
    }
  }

  function enhance(scope) {
    ensureDrawer();

    var rootScope = scope && scope.querySelectorAll ? scope : document;
    var containers = Array.prototype.slice.call(
      rootScope.querySelectorAll('#MainContent .product__info-container, .product__info-container')
    );

    if (rootScope.matches && rootScope.matches('.product__info-container')) {
      containers.unshift(rootScope);
    }

    containers = containers.filter(function (container, index, array) {
      return array.indexOf(container) === index;
    });

    containers.forEach(function (container) {
      var blocks = Array.prototype.slice.call(
        container.querySelectorAll('.product__accordion.accordion.quick-add-hidden')
      );

      blocks.forEach(enhanceBlock);
      refreshEdgeClasses(container);
    });
  }

  function init() {
    enhance(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhance(event.target || document);
  });

  window.addEventListener('pageshow', function () {
    enhance(document);
  });
})();
